var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnsuccessfulWorkflows = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "current",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.5 8H4m0-2v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#111928",
  fillRule: "evenodd",
  d: "M16.873 12.104c.14.14.14.365.002.505l-1.871 1.88 1.892 1.902a.357.357 0 1 1-.506.504l-1.89-1.9-1.89 1.9a.357.357 0 0 1-.506-.504l1.892-1.902-1.87-1.88a.357.357 0 0 1 .506-.504l1.868 1.878 1.868-1.878c.14-.14.366-.14.505-.001",
  clipRule: "evenodd"
})));
export { SvgUnsuccessfulWorkflows as ReactComponent };
export default __webpack_public_path__ + "61a4379dfb6e6d1447f93536aed1a25a.svg";